import React, { useState, useEffect } from "react";
import BlogDetails from "../components/BlogDetails";
import Navbar from "../components/Navbar";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import { fetchData } from "../services/api";

interface PlanningTripData {
  text: string;
  description: string;
}

interface BannerData {
  bannerText: string;
  subText: string;
  bannerVideo: string;
}

interface MetaData {
  metaKeyword: string;
  metaDescription: string;
  metaTitle: string;
}

const BlogDetailing: React.FC = () => {
  
  const [metaData, setMetaData] = useState<MetaData>({
    metaKeyword: "",
    metaDescription: "",
    metaTitle: "",
  });

  const [bannerData, setBannerData] = useState<BannerData>({
    bannerText: "",
    subText: "",
    bannerVideo: "",
  });

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
        const response = await fetchData<{
          meta_keyword: string;
          meta_description: string;
          meta_title: string;
          banner: {
            bannerId: string;
            bannerText: string;
            subText: string;
            bannerVideo: string;
          }[];
        }>({
          url: "/blogs/list",
        });

        const data = response?.data;
        if (data) {
          setMetaData({
            metaTitle: data.meta_title,
            metaKeyword: data.meta_keyword,
            metaDescription: data.meta_description,
          });

          if (data.banner?.length > 0) {
            console.log("Banner Data:", data.banner[0]);
            setBannerData(data.banner[0]);
          }
        } else {
          throw new Error("Metadata not found.");
        }
      } catch (error) {
        console.error("Error fetching metadata:", error);
        setError("Failed to load metadata.");
      }
    };

    fetchMetaData();
  }, []);
  return (
    <div>
      {bannerData.bannerText && (
        <Navbar
          heading={bannerData.bannerText}
          subHeading={bannerData.subText}
          video={bannerData.bannerVideo}
        />
      )}
      <BlogDetails />
      <PlanningTrip
        headingplanning="Where to next?
"
        paragraph="We’ll create a vacation you’ll remember forever."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default BlogDetailing;
